import { render, staticRenderFns } from "./LinkedQuestionModal.vue?vue&type=template&id=10d46543&scoped=true&"
import script from "./LinkedQuestionModal.vue?vue&type=script&lang=js&"
export * from "./LinkedQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./LinkedQuestionModal.vue?vue&type=style&index=0&id=10d46543&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d46543",
  null
  
)

export default component.exports